// "use client"

// import { useState, useEffect } from "react"
// import { Link, useNavigate, useParams } from "react-router-dom"
// import { baseUrl } from "../../config/baseUrl"
// import { toast } from "react-toastify"
// import axios from "axios"

// export default function CouponEdit() {
//     const navigate = useNavigate()
//     const { id } = useParams()
//     const [loading, setLoading] = useState(false)
//     const [fetchLoading, setFetchLoading] = useState(true)
//     const [formval, setFormval] = useState({
//         coupon_code: "",
//         discount: "",
//         start_date: "",
//         end_date: "",
//         status: "true",
//     })

//     useEffect(() => {
//         if (id) {
//             fetchCouponDetails()
//         }
//     }, [id])

//     const fetchCouponDetails = async () => {
//         try {
//             setFetchLoading(true)
//             const response = await axios.get(`${baseUrl}/api/v1/admin/coupon/coupon/${id}`, {
//                 headers: {
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })

//             if (response.status === 200) {
//                 const couponData = response.data.data
//                 setFormval({
//                     coupon_code: couponData.coupon_code || "",
//                     discount: couponData.discount || "",
//                     start_date: couponData.start_date ? couponData.start_date.split("T")[0] : "",
//                     end_date: couponData.end_date ? couponData.end_date.split("T")[0] : "",
//                     status: couponData.status || "true",
//                 })
//             }
//         } catch (error) {
//             console.error("Error fetching coupon:", error)
//             toast.error("Failed to fetch coupon details")
//             navigate("/coupons")
//         } finally {
//             setFetchLoading(false)
//         }
//     }

//     const changeHandler = (e) => {
//         setFormval((preVal) => ({ ...preVal, [e.target.name]: e.target.value }))
//     }

//     // Validation function
//     const validateForm = () => {
//         const { coupon_code, discount, start_date, end_date } = formval

//         if (!coupon_code.trim()) {
//             toast.error("Coupon code is required")
//             return false
//         }

//         if (!discount || discount <= 0 || discount > 100) {
//             toast.error("Discount must be between 1 and 100")
//             return false
//         }

//         if (!start_date) {
//             toast.error("Start date is required")
//             return false
//         }

//         if (!end_date) {
//             toast.error("End date is required")
//             return false
//         }

//         if (new Date(end_date) <= new Date(start_date)) {
//             toast.error("End date must be after start date")
//             return false
//         }

//         return true
//     }

//     const handleSubmit = async (e) => {
//         e.preventDefault()

//         if (!validateForm()) {
//             return
//         }

//         try {
//             setLoading(true)
//             const response = await axios.put(`${baseUrl}/api/v1/admin/coupon/coupon-update/${id}`, formval, {
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: localStorage.getItem("token"),
//                 },
//             })

//             if (response.status === 200) {
//                 toast.success("Coupon updated successfully")
//                 navigate("/coupons")
//             }
//         } catch (error) {
//             console.error("Error:", error)
//             if (error.response?.data?.message) {
//                 toast.error(error.response.data.message)
//             } else {
//                 toast.error("Failed to update coupon")
//             }
//         } finally {
//             setLoading(false)
//         }
//     }

//     if (fetchLoading) {
//         return (
//             <section className="main-sec">
//                 <div className="text-center py-5">
//                     <div className="spinner-border" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                     </div>
//                     <p className="mt-2">Loading coupon details...</p>
//                 </div>
//             </section>
//         )
//     }

//     return (
//         <>
//             <section className="main-sec">
//                 <div className="row align-items-center">
//                     <div className="col-lg-6">
//                         <div className="dashboard-title">
//                             <h4 className="dash-head">
//                                 <i className="fa fa-edit me-2" />
//                                 Edit Coupon
//                             </h4>
//                         </div>
//                         <div className="custom-bredcump">
//                             <nav aria-label="breadcrumb">
//                                 <ol className="breadcrumb">
//                                     <li className="breadcrumb-item">
//                                         <Link to="/">Dashboard</Link>
//                                     </li>
//                                     <li className="breadcrumb-item">
//                                         <Link to="/coupons">Coupons</Link>
//                                     </li>
//                                     <li className="breadcrumb-item active" aria-current="page">
//                                         Edit Coupon
//                                     </li>
//                                 </ol>
//                             </nav>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 d-flex justify-content-end">
//                         <Link to="/coupons" className="btn btn-info text-white">
//                             <i className="fa fa-arrow-left me-1"></i>
//                             Back
//                         </Link>
//                     </div>
//                 </div>
//                 <div className="row">
//                     <div className="col-lg-12">
//                         <div className="cards edit-usr">
//                             <form onSubmit={handleSubmit}>
//                                 <div className="row">
//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="coupon_code" className="form-label">
//                                             Coupon Code<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="text"
//                                             className="form-control"
//                                             name="coupon_code"
//                                             id="coupon_code"
//                                             placeholder="Enter coupon code (e.g., SAVE20)"
//                                             onChange={changeHandler}
//                                             value={formval?.coupon_code}
//                                             required
//                                             style={{ textTransform: "uppercase" }}
//                                         />
//                                     </div>
//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="discount" className="form-label">
//                                             Discount (%)<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="number"
//                                             className="form-control"
//                                             name="discount"
//                                             id="discount"
//                                             placeholder="Enter discount percentage"
//                                             onChange={changeHandler}
//                                             value={formval?.discount}
//                                             min="1"
//                                             max="100"
//                                             required
//                                         />
//                                     </div>

//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="start_date" className="form-label">
//                                             Start Date<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="date"
//                                             className="form-control"
//                                             name="start_date"
//                                             id="start_date"
//                                             onChange={changeHandler}
//                                             value={formval?.start_date}
//                                             required
//                                         />
//                                     </div>

//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="end_date" className="form-label">
//                                             End Date<sup className="text-danger">*</sup>
//                                         </label>
//                                         <input
//                                             type="date"
//                                             className="form-control"
//                                             name="end_date"
//                                             id="end_date"
//                                             onChange={changeHandler}
//                                             value={formval?.end_date}
//                                             min={formval.start_date || ""}
//                                             required
//                                         />
//                                     </div>

//                                     <div className="col-lg-6 mb-4">
//                                         <label htmlFor="status" className="form-label">
//                                             Status<sup className="text-danger">*</sup>
//                                         </label>
//                                         <select
//                                             className="form-control"
//                                             name="status"
//                                             id="status"
//                                             onChange={changeHandler}
//                                             value={formval?.status}
//                                         >
//                                             <option value="true">Active</option>
//                                             <option value="false">Inactive</option>
//                                         </select>
//                                     </div>

//                                     <div className="col-lg-12 text-center">
//                                         <button type="submit" className="btn btn-for-add text-white" disabled={loading}>
//                                             {loading ? (
//                                                 <>
//                                                     <span className="spinner-border spinner-border-sm me-2"></span>
//                                                     Updating...
//                                                 </>
//                                             ) : (
//                                                 <>
//                                                     <i className="fa fa-save me-1"></i>
//                                                     Update Coupon
//                                                 </>
//                                             )}
//                                         </button>
//                                     </div>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     )
// }

"use client"

import { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { baseUrl } from "../../config/baseUrl"
import { toast } from "react-toastify"
import axios from "axios"

export default function CouponEdit() {
    const navigate = useNavigate()
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [fetchLoading, setFetchLoading] = useState(true)
    const [formval, setFormval] = useState({
        coupon_code: "",
        discount: "",
        start_date: "",
        end_date: "",
        status: "true",
    })

    useEffect(() => {
        if (id) {
            fetchCouponDetails()
        }
    }, [id])

    const fetchCouponDetails = async () => {
        try {
            setFetchLoading(true)
            const response = await axios.get(`${baseUrl}/api/v1/admin/coupon/coupon/${id}`, {
                headers: {
                    Authorization: localStorage.getItem("token"),
                },
            })

            if (response.status === 200) {
                const couponData = response.data.data
                setFormval({
                    coupon_code: couponData.coupon_code || "",
                    discount: couponData.discount || "",
                    start_date: couponData.start_date ? couponData.start_date.split("T")[0] : "",
                    end_date: couponData.end_date ? couponData.end_date.split("T")[0] : "",
                    status: couponData.status || "true",
                })
            }
        } catch (error) {
            console.error("Error fetching coupon:", error)
            toast.error("Failed to fetch coupon details")
            navigate("/coupons")
        } finally {
            setFetchLoading(false)
        }
    }

    const changeHandler = (e) => {
        setFormval((preVal) => ({ ...preVal, [e.target.name]: e.target.value }))
    }

    // Validation function
    const validateForm = () => {
        const { coupon_code, discount, start_date, end_date } = formval

        if (!coupon_code.trim()) {
            toast.error("Coupon code is required")
            return false
        }

        if (!discount || discount <= 0 || discount > 100) {
            toast.error("Discount must be between 1 and 100")
            return false
        }

        if (!start_date) {
            toast.error("Start date is required")
            return false
        }

        if (!end_date) {
            toast.error("End date is required")
            return false
        }

        if (new Date(end_date) <= new Date(start_date)) {
            toast.error("End date must be after start date")
            return false
        }

        return true
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!validateForm()) {
            return
        }

        try {
            setLoading(true)
            const response = await axios.put(`${baseUrl}/api/v1/admin/coupon/coupon-update/${id}`, formval, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("token"),
                },
            })

            if (response.status === 200) {
                toast.success("Coupon updated successfully")
                navigate("/coupons")
            }
        } catch (error) {
            console.error("Error:", error)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error("Failed to update coupon")
            }
        } finally {
            setLoading(false)
        }
    }

    if (fetchLoading) {
        return (
            <section className="main-sec">
                <div className="text-center py-5">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading coupon details...</p>
                </div>
            </section>
        )
    }

    return (
        <>
            <section className="main-sec">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="dashboard-title">
                            <h4 className="dash-head">
                                <i className="fa fa-edit me-2" />
                                Edit Coupon
                            </h4>
                        </div>
                        <div className="custom-bredcump">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/coupons">Coupons</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Edit Coupon
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-end">
                        <Link to="/coupons" className="btn btn-info text-white">
                            <i className="fa fa-arrow-left me-1"></i>
                            Back
                        </Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="cards edit-usr">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="coupon_code" className="form-label">
                                            Coupon Code<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="coupon_code"
                                            id="coupon_code"
                                            placeholder="Enter coupon code (e.g., SAVE20)"
                                            onChange={changeHandler}
                                            value={formval?.coupon_code}
                                            required
                                            style={{ textTransform: "uppercase" }}
                                        />
                                    </div>
                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="discount" className="form-label">
                                            Discount (%)<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="discount"
                                            id="discount"
                                            placeholder="Enter discount percentage"
                                            onChange={changeHandler}
                                            value={formval?.discount}
                                            min="1"
                                            max="100"
                                            required
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="start_date" className="form-label">
                                            Start Date<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="start_date"
                                            id="start_date"
                                            onChange={changeHandler}
                                            value={formval?.start_date}
                                            required
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="end_date" className="form-label">
                                            End Date<sup className="text-danger">*</sup>
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="end_date"
                                            id="end_date"
                                            onChange={changeHandler}
                                            value={formval?.end_date}
                                            min={formval.start_date || ""}
                                            required
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-4">
                                        <label htmlFor="status" className="form-label">
                                            Status<sup className="text-danger">*</sup>
                                        </label>
                                        <select
                                            className="form-control"
                                            name="status"
                                            id="status"
                                            onChange={changeHandler}
                                            value={formval?.status}
                                        >
                                            <option value="true">Active</option>
                                            <option value="false">Inactive</option>
                                        </select>
                                    </div>

                                    <div className="col-lg-12 text-center">
                                        <button type="submit" className="btn btn-for-add text-white" disabled={loading}>
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Updating...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa fa-save me-1"></i>
                                                    Update Coupon
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
